import { createUseStyles } from '@pe-libs/react-components/build/theme';

const useStyles = createUseStyles(
  'expert-directory-single-item-list',
  ({
    breakpoints: { up, down },
    shape,
    palette: { background, grey, primary, warning, secondary, common },
    typography,
  }) => ({
    singleBoxContainer: {
      position: 'relative',
      height: 'auto',
      maxWidth: '47.8125rem',
      margin: '0 auto 1rem',
    },
    counterAndIndustryContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '0.25rem',
    },
    counter: {
      position: 'relative',
      height: '1.5rem',
      fontSize: '1rem',
      letterSpacing: '0.15px',
      color: background.paper,
      background: warning.main,
      fontWeight: typography.fontWeightSemiBold,
      lineHeight: '1.5rem',
      textAlign: 'center',
      borderRadius: shape.borderRadius,
      padding: '0 0.19rem',
      marginRight: '0.5rem',
    },
    counterMinWidth: {
      minWidth: '1.5rem',
    },
    singleBoxContentContainer: {
      padding: '1.5rem 1rem',
      '&:focus': {
        outline: 'none',
      },
      [up('sm')]: {
        padding: '1.5rem',
      },
    },
    starsContainer: {
      display: 'flex',
      alignItems: 'center',
      paddingTop: '0.15rem',
      paddingBottom: '0.35rem',
    },
    starsSvgContainer: {
      fontSize: '1.1rem',
    },
    starsText: {
      paddingLeft: '0.35rem',
      fontWeight: typography.fontWeightSemiBold,
      lineHeight: '1.099375rem',
      color: grey[800],
    },
    sourcesText: {
      color: grey[500],
      marginLeft: '0.25rem',
    },
    sourcesTextFlex: {
      display: 'flex',
      alignItems: 'center',
      color: grey[500],
      '& p': {
        color: 'initial',
        fontWeight: typography.fontWeightLight,
        marginRight: '0.25rem',
      },
    },
    linkContainer: {
      display: 'flex',
      justifyContent: 'flex-end',
      fontSize: '1rem',
    },
    title: {
      display: 'inline-block',
      marginBottom: '0.5rem',

      '&:hover': {
        textDecoration: 'underline',
      },
    },
    labelsContainer: {
      marginTop: '0.75rem',
      marginBottom: '1.0625rem',

      [up('sm')]: {
        marginTop: '1rem',
        marginBottom: '1rem',
      },
      '& .MuiChip-root': {
        margin: '0 0.375rem 0.375rem 0',
        [up('sm')]: {
          margin: '0 0.5rem 0.375rem 0',
        },
      },
      '& .MuiChip-label': {
        whiteSpace: 'normal',
      },
      '& > div': {
        fontSize: '10px',
        height: 'auto',
        paddingTop: '2px',
        paddingBottom: '2px',
        textTransform: 'uppercase',
      },
    },
    contactDetailsContainer: {
      margin: '1rem 0',
      minHeight: 0,
    },
    locationDetails: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    address: {
      fontWeight: typography.fontWeightSemiBold,
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        fontSize: '1rem',
        color: primary.main,
        marginRight: '0.25rem',
      },
    },
    detailsContainer: {
      display: 'flex',
      flexDirection: 'column',
      fontSize: '0.875rem',
      paddingTop: '1rem',
      borderTop: `1px solid ${grey[200]}`,

      [up('sm')]: {
        flexDirection: 'row',
      },
    },
    contactDetails: {
      display: 'flex',
      marginTop: '0.25rem',

      [down('xs')]: {
        flexWrap: 'wrap',
      },
      '& a': {
        lineHeight: '1.3125rem',
        letterSpacing: '0.15px',
        marginRight: '1rem',
        [up('md')]: {
          marginRight: '1.25rem',
          lineHeight: '1.5rem',
        },
      },
    },
    detailsDesc: {
      paddingTop: '1rem',
    },
    avatarAndStarsContainer: {
      display: 'flex',
    },
    avatarContainer: {
      width: '3rem',
      height: '3rem',
      flexShrink: 0,
      backgroundSize: 'cover',
      borderRadius: shape.borderRadius,
      marginRight: '0.75rem',
      overflow: 'hidden',
      border: `1px solid ${grey[200]}`,
    },
    awardsContainer: {
      display: 'flex',
      flexGrow: 1,
      flexWrap: 'wrap',
      fontSize: '1rem',
      marginLeft: '-0.8rem',
      marginTop: '0.25rem',

      [up('sm')]: {
        justifyContent: 'flex-end',
        marginTop: 0,
      },
    },
    checkIcon: {
      width: '0.75rem',
      marginLeft: '0.2rem',
    },
    awardLabel: {
      height: '1.125rem',
      lineHeight: '1.125rem',
      whiteSpace: 'nowrap',
      borderRadius: '4px',
      padding: '0 0.5rem',
      color: common.white,
      fontSize: '0.625rem',
      fontWeight: typography.fontWeightSemiBold,
      marginLeft: '0.8rem',
      marginTop: '0.75rem',
      textTransform: 'uppercase',

      [up('sm')]: {
        marginTop: 0,
        marginLeft: '0.5rem',
      },
    },
    gradientPrimary: {
      background: `linear-gradient(to right, ${primary.main}, ${primary.dark})`,
    },
    gradientSecondary: {
      background: `linear-gradient(to right, ${secondary.main}, ${secondary.dark})`,
    },
    semiBold: {
      fontWeight: typography.fontWeightSemiBold,
    },
    tooltipNoStarsContainer: {
      display: 'inline-flex',
      paddingBottom: '0.1rem',
    },
    noStarsTooltip: {
      height: '1.3125rem',
      display: 'flex',
      alignItems: 'center',
      color: grey[500],
      fontSize: '0.75rem',
      marginLeft: '0.3rem',
      textAlign: 'left',
    },
    industryFieldContainer: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      minHeight: '1.5rem',
    },
    industryFieldLink: {
      '& a': {
        color: grey[500],
      },
    },
    redirectionIcon: {
      '& svg': {
        fontSize: '1rem',
        color: grey[500],
      },
      '& a': {
        width: '2.75rem',
        height: '2rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: shape.borderRadius,
        marginRight: '-0.5rem',
        marginTop: '-0.5rem',
        '&:hover': {
          background: primary.light,
          transition: 'all 0.3s',
          '&:after': {
            display: 'none',
          },
          '& svg': {
            color: primary.main,
          },
        },
      },
    },
    cutLongLink: {
      maxWidth: '15rem',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
    },
    tooltipTitle: {
      textAlign: 'left',
      fontWeight: typography.fontWeightBold,
      lineHeight: '1.313rem',
    },
    tooltipList: {
      textAlign: 'left',
      paddingLeft: '1.2rem',
      margin: '0.5em 0',
      lineHeight: '1.313rem',
    },
    tooltipListItem: {
      paddingBottom: '0.5rem',
    },
    tooltipLink: {
      textDecoration: 'underline',
    },
  }),
);

export default useStyles;
